import React, { useEffect, useState } from "react";
import { MdReviews } from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { useForm } from "react-hook-form";
import Image from "next/image";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import Link from "next/link";
import { getLocals } from "../../../getLocal";
import { hostNameFunction } from "../../../utils/host-function";
import axios from "axios";
import { deleteApi } from "../../../utils/apiRoute";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import ListingForm from "../common/ListingForm";

export default function TopImage({
  data,
  part,
  apiData,
  countryName,
  countryTranslations,
  hostname,
}) {
  const [localizedStrings, setLocalizedStrings] = useState();
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [isValid, setIsValid] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const [inputValue, setInputValue] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const route = useRouter();

  useEffect(() => {
    const fetchLocalizedStrings = async () => {
      const lang = hostNameFunction() || "en";
      const strings = await getLocals(lang);
      setLocalizedStrings(strings);
    };

    fetchLocalizedStrings();
  }, []);
  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      businessId: apiData.id,
      businessName: apiData.name,
      businessSlug: apiData.slug,
    };

    if (!isValid) {
      setCaptchaError("Fill Captcha");
      return;
    }
    try {
      const response = await axios.post(deleteApi, updatedData);
      if (response.data.status === "success") {
        toast.success(
          "Your request is sent to admin as soon as we will proceed your request"
        );
        route.push("/");
      } else {
        toast.error("Something went wrong! Please try Again");
        route.push("/");
      }
      console.log("Form submitted successfully!", response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  function generateCaptcha() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  function handleInputChange(event) {
    const value = event.target.value;
    setInputValue(value);
    if (value === captcha) {
      setIsValid(true);
      setCaptchaError("");
    } else {
      setIsValid(false);
      setCaptchaError(value.length === 0 ? "" : "Wrong Captcha");
    }
  }

  const generateNewCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 4; // Set the length of the captcha code
    let newCaptcha = "";
    for (let i = 0; i < length; i++) {
      newCaptcha += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return newCaptcha;
  };

  const refreshCaptcha = () => {
    const newCaptcha = generateNewCaptcha();
    setCaptcha(newCaptcha);
    setInputValue("");
    setIsValid(false);
    setCaptchaError("");
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);
  const [openForm, setOpenForm] = React.useState(false);
  const handleOpenForm = () => setOpenForm(!openForm);
  const border = `border-none`;
  const button = `${
    localizedStrings && localizedStrings.Index.newListing.btn2
  }`;
  const width = "w-full";
  const heading = `${
    localizedStrings && localizedStrings.Index.newListing.heading2
  } ${
    localizedStrings && localizedStrings.Index.BusinessPage.Paragraph.line6.con2
  } ${countryTranslations?.[1]}`;

  const handleFullNameBlur = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabetic characters
    setValue("name", value, { shouldValidate: true });
  };

  const handleFullNameChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabetic characters
    setValue("name", value);
  };

  return (
    <>
      {data.map((item, index) => (
        <div key={index}>
          <div className="pb-16">
            {item.vectorImage ? (
              <Image
                src={`/assets/img/categories/${item.vectorImage}`}
                className="object-cover w-full md:h-[225px] "
                width={1000}
                height={1000}
                alt="image"
                loading="eager"
              />
            ) : (
              <Image
                src="/assets/img/categories/default.webp"
                className="object-cover w-full h-[225px]"
                width={1000}
                height={1000}
                alt="image"
                loading="eager"
              />
            )}
          </div>
          <div className="flex items-center justify-center pb-2">
            <div className="md:p-4 p-2 w-full md:w-auto mx-2 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 md:flex dark:border-gray-700 mt-[-5em]">
              <div className="flex justify-center md:items-center">
                {item.icon ? (
                  <div className="">
                    <Image
                      src={`/assets/img/icons/${item.icon}`}
                      className="md:h-[60px] md:w-[60px] pb-5 w-10"
                      width={12}
                      height={12}
                      alt="image"
                    />
                  </div>
                ) : (
                  <div>
                    <Image
                      src={`/assets/img/icons/default-category.svg`}
                      className="md:h-[50px] md:w-[50px] pb-5 w-10"
                      width={12}
                      height={12}
                      alt="image"
                    />
                  </div>
                )}
              </div>

              <div className="">
                <p className="pb-2 text-xl mb-5 md:mb-1">
                  <b>{item.businessName}</b>
                </p>
                <div className="flex mb-5 justify-between px-5 md:gap-5">
                  <div className="flex items-center ">
                    <div>
                      <Link href="#form1">
                        <button className="flex items-center text-base md:text-lg gap-1">
                          <MdReviews />{" "}
                          {localizedStrings &&
                            localizedStrings.Index.BusinessPage.btn1}
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="flex items-center ">
                    <div>
                      <button
                        className="flex items-center text-base md:text-lg gap-1"
                        onClick={handleOpenForm}
                        variant="gradient"
                      >
                        <MdModeEdit />{" "}
                        {localizedStrings &&
                          localizedStrings.Index.BusinessPage.btn2}
                      </button>
                      <Dialog
                        open={openForm}
                        handler={handleOpenForm}
                        className="overflow-y-auto max-h-[100%] md:max-h-[600px]"
                      >
                        <ListingForm
                          border={border}
                          editData={item}
                          button={button}
                          width={width}
                          heading={heading}
                          getData={apiData}
                        />
                      </Dialog>
                    </div>
                  </div>
                  <div className="flex items-center ">
                    <div>
                      <button
                        onClick={handleOpen}
                        variant="gradient"
                        className="flex items-center text-base md:text-lg gap-1"
                      >
                        <MdDelete />{" "}
                        {localizedStrings &&
                          localizedStrings.Index.BusinessPage.btn3}
                      </button>
                      <Dialog
                        open={open}
                        handler={handleOpen}
                        className="overflow-y-auto h-[40%] md:h-[95%]"
                      >
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <DialogHeader className="flex items-center gap-2">
                            <Image
                              src="/assets/img/delete.svg"
                              height={30}
                              width={30}
                              alt="image"
                            />
                            <h3 className="block font-sans text-2xl antialiased font-semibold leading-snug tracking-normal text-black">
                              {localizedStrings &&
                                localizedStrings.Index.Dialog.heading}
                            </h3>
                          </DialogHeader>
                          <DialogBody>
                            <div className="mb-4">
                              <input
                                type="text"
                                id="name"
                                name="name"
                                {...register("name", {
                                  required: "Your Name is required",
                                  pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message:
                                      "Please enter a valid name (letters and spaces only)",
                                  },
                                })}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-[16px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={
                                  localizedStrings &&
                                  localizedStrings.Index.Dialog.placeholder1
                                }
                                onBlur={handleFullNameBlur}
                                onChange={handleFullNameChange}
                              />
                              {errors.name && (
                                <span className="text-red-500 text-sm">
                                  {errors.name.message}
                                </span>
                              )}
                            </div>
                            <div className="mb-4">
                              <input
                                type="email"
                                id="email"
                                name="email"
                                {...register("email", {
                                  required: "Email is required",
                                  pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Invalid email address",
                                  },
                                })}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-[16px]  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={
                                  localizedStrings &&
                                  localizedStrings.Index.Dialog.placeholder2
                                }
                              />
                              {errors.email && (
                                <span className="text-red-500 text-sm">
                                  {errors.email.message}
                                </span>
                              )}
                            </div>
                            <div className="mb-4">
                              <select
                                id="reason"
                                name="reason"
                                {...register("reason", {
                                  required: "Selection is must",
                                })}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-[16px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              >
                                <option value="">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.label3}
                                </option>
                                <option value="1">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.option1}
                                </option>
                                <option value="2">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.option2}
                                </option>
                                <option value="3">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.option3}
                                </option>
                                <option value="4">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.option4}
                                </option>
                                <option value="5">
                                  {localizedStrings &&
                                    localizedStrings.Index.Dialog.option5}
                                </option>
                              </select>
                              {errors.reason && (
                                <span className="text-red-500 text-sm">
                                  {errors.reason.message}
                                </span>
                              )}
                            </div>
                            <div className="mb-4">
                              <textarea
                                id="message"
                                name="message"
                                rows="4"
                                {...register("message", {
                                  required:
                                    "Please write explanation so that we will start to proceed your request",
                                })}
                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={
                                  localizedStrings &&
                                  localizedStrings.Index.Dialog.label4
                                }
                              ></textarea>
                              {errors.message && (
                                <span className="text-red-500 text-sm">
                                  {errors.message.message}
                                </span>
                              )}
                            </div>
                            <div className="flex pb-2">
                              <div className="text-lg font-bold border border-gray-300 px-3 py-2 inline-block mr-4">
                                {captcha}
                              </div>
                              <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                className={`border px-3 py-2 rounded-md mr-4 ${
                                  isValid === null
                                    ? ""
                                    : isValid
                                    ? "border-green-500"
                                    : "border-red-500"
                                }`}
                                placeholder={
                                  localizedStrings &&
                                  localizedStrings.Index.BusinessPage.Captcha
                                }
                              />
                              {captchaError && (
                                <span className="text-red-500">
                                  {captchaError}
                                </span>
                              )}
                              <button
                                type="button"
                                className="flex items-center px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-indigo-600 rounded-lg hover:bg-indigo-500 focus:outline-none focus:ring focus:ring-indigo-300 focus:ring-opacity-80"
                                onClick={refreshCaptcha}
                              >
                                <svg
                                  className="w-5 h-5 mx-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </button>
                            </div>
                          </DialogBody>
                          <DialogFooter>
                            <button
                              type="submit"
                              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm !w-[100%] sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            >
                              {localizedStrings &&
                                localizedStrings.Index.Dialog.button}
                            </button>
                          </DialogFooter>
                        </form>
                      </Dialog>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
